import { useAuth } from "oidc-react";
import { useEffect, useState } from "react";

const LicenseBackground = () => {
    const auth = useAuth();
    const [imagePath, setImagePath] = useState('');


    useEffect(() => {
        let themeName = auth.userData?.profile.theme as String;
        const newPath = "/theme/" + themeName + "/background_license.jpg";

        setImagePath(newPath);

    }, [auth.userData?.profile.theme]);


    return (
        <img 
            src={imagePath} 
            alt='License expired' 
            style={{ zIndex: 2 }} 

            // onError={() => {
            //     // default Logo bei Fehler?
            //     const themeName = "wms";
            //     const newPath = "/theme/" + themeName + "/background.jpg";

            //     setImagePath(newPath);
            // }}
        />
    );
}

export default LicenseBackground;